import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Faq = ({ items, testId = "seo-faq-accordion" }) => {
  if (!items || items.length === 0) return null;
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={testId}>
      {items.map((it, idx) => (
        <AccordionItem key={idx} value={`item-${idx}`} data-testid="seo-faq-item">
          <AccordionTrigger className="text-left font-heading">{it.q}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed">{it.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
